import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  padLeadingZeros(num, size) : string{
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

  getCurrentDate() : string {
    let current_datetime = new Date()
    var currentMonth = this.padLeadingZeros(current_datetime.getMonth() + 1, 2)
    var currentDay = this.padLeadingZeros(current_datetime.getDate(), 2)
    var dateNow = current_datetime.getFullYear() + "-" + currentMonth + "-" + currentDay;

    return dateNow;
  }

  presentToast(msg : string, duration : number = 3000) {
    const toast = document.createElement('ion-toast');
    toast.message = msg;
    toast.duration = duration;
  
    document.body.appendChild(toast);
    return toast.present();
  }
}
